import { clsx } from "clsx";

export const KeyboardKey = ({ kbdKey }: { kbdKey: string | React.ReactNode }) => {
  return (
    <span
      className={clsx(
        "hidden md:flex items-center justify-center py-1 rounded-sm bg-background-input border border-border-action",
        typeof kbdKey === "string" ? "px-2" : "px-1"
      )}
    >
      <span className="text-text-base-tertiary text-2xs">{kbdKey}</span>
    </span>
  );
};
